module.exports = "<div class=\"add-bank-info\" ng-controller=\"AddBankInfoController as addBankInfo\">\n    <hp-ach cancel-click=\"addBankInfo.cancelAdd()\" ach-data=\"addBankInfo.financeInfo\" save-click=\"addBankInfo.add()\" display-logo=\"false\" notification-view=\"true\"></hp-ach>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/notificationCenter/modal/templates/addBankInfo/addBankInfo.html
// module id = 741
// module chunks = 1